import { EventBroker } from './EventBroker';
export const ServiceCalls = {
  serviceURL: 'service/service.php',
  finalCalled: false,
  union: function (json) {
    return $.ajax({
      url: `nodeservice/union`,
      type: 'POST',
      data: {
        json,
      },
    });
  },
  getParcels: function (body) {
    return new Promise((res, rej) => {
      $.ajax({
        url: 'nodeservice/titles/byPoly/count',
        type: 'POST',
        data: {
          poly: body.poly,
        },
      }).always(data => {
        if (typeof data === 'string') data = parseInt(data);
        if (data) res(data);
      });
    });
  },
  callService: function (calltype, object, special = null) {
    let ajaxObj = { url: this.serviceURL, type: 'POST' };
    ajaxObj.data = {};
    ajaxObj.data.request = calltype;
    switch (calltype) {
      case 'getCoordsFromUPRN':
        ajaxObj.url = `nodeservice/getCoordsFromUPRN?uprns=${object.uprns}`;
        ajaxObj.type = 'GET';
        break;
      case 'updatePolys':
        break;
      case 'getLayersFromExtent':
        ajaxObj.url = 'nodeservice/getLayersFromExtent';
        ajaxObj.data.extent = JSON.stringify(object.extent);
        break;
      case 'search':
        ajaxObj.url = `nodeservice/titles/byTitle?title=${object.title}`;
        ajaxObj.type = 'GET';
        break;
      case 'getUpdated':
        ajaxObj.url = 'nodeservice/getUpdated';
        ajaxObj.type = 'GET';
        break;
      case 'createPDF':
        ajaxObj.url = 'nodeservice/createPDF';
        ajaxObj.data.image = object.image;
        ajaxObj.data.json = object.json;
        ajaxObj.data.log = object.log;
        ajaxObj.data.search = object.search;
        ajaxObj.data.sessionId = object.sessionId;
        ajaxObj.data.projectId = object.projectId;
        ajaxObj.data.address = object.address;
        ajaxObj.data.extent = object.extent;
        ajaxObj.data.casefile = object.casefile;
        ajaxObj.data.extentString = object.extentString;
        ajaxObj.data.endpoint = object.endpoint;
        break;
      case 'createSnapshotReport':
        ajaxObj.url = 'nodeservice/createSnapshotReport';
        ajaxObj.data = { ...ajaxObj.data, ...object };
        break;
      case 'finalcall':
        ajaxObj.data.sessionid = object.sessionid;
        ajaxObj.data.json = object.json;
        break;
      case 'logPlanningView':
        ajaxObj.data.guid = object.guid;
        ajaxObj.data.xy = object.xy;
        break;
      case 'getAddress':
        ajaxObj.data.uprn = object.uprn;
        break;
      case 'getIntersects':
        ajaxObj.data.poly = object.poly;
        ajaxObj.data.json = object.json;
        ajaxObj.data.limit = 2000;
        ajaxObj.data.buffer = object.buffer;
        ajaxObj.data.snapsActive = object.snapsActive;
        break;
      case 'getAddressInPoly':
      case 'getAddressFromPoly':
      case 'getAddressFromBoundary':
        ajaxObj.url = 'nodeservice/address/byPoly';
        ajaxObj.data.poly = object.poly;
        break;
      case 'getAddressFromPoint':
        ajaxObj.data.pointx = object.pointx;
        ajaxObj.data.pointy = object.pointy;
        ajaxObj.data.poly = object.poly;
        break;
      case 'saveArea':
        ajaxObj.data.screenarea = object.screenarea;
        ajaxObj.data.guid = object.guid;
        break;
      case 'saveoverlay':
        ajaxObj.data.screenarea = object.screenarea;
        ajaxObj.data.guid = object.guid;
        ajaxObj.data.layer = object.layer;
        break;
      case 'getTitleFromPoint':
        ajaxObj.data.lon = object.lonlat.lon;
        ajaxObj.data.lat = object.lonlat.lat;
        break;
      case 'updateStatus':
        ajaxObj.data.json = object.json;
        ajaxObj.data.anno = object.anno;
        ajaxObj.data.guid = object.guid;
        ajaxObj.data.projectid = object.projectid;
        break;
      default:
        break;
    }
    if (calltype == 'finalcall' && this.finalCalled) {
      return;
    }
    if (ajaxObj) {
      if (calltype == 'finalcall') this.finalCalled = true;
      $('html,body,#map').css('cursor', 'wait');
      $.ajax(ajaxObj).always(function (response) {
        $('html,body,#map').css('cursor', 'pointer');
        EventBroker.broadcast({
          type: calltype + 'Result',
          response: response,
          callingObj: object,
          special,
        });
      });
    }
  },
};
